import { housesDict } from "../HouseInfo";
import Property from "../../components/Property/Property";

function LakeOne() {
  return (
    <div>
      <Property
        {...{
          housesDict: housesDict["C005"],
          propertyId: "65c270d93886dd758c1690fc",
        }}
      />

      {/* <Property {...housesDict["C005"]} /> */}
    </div>
  );
}

export default LakeOne;
